import { Popover } from '@gate/gui'
import { Drawer } from '@mantine/core'
import styled from 'styled-components'

export const BasePopoverTargetStyled = styled(Popover.Target)<{ width?: string }>`
  width: ${({ width }) => width ?? 'fit-content'};

  .popover-icon {
    transform: rotate(0deg);
  }

  &[aria-expanded='true'] {
    .popover-icon {
      transform: rotate(180deg);
    }
  }
`

export const BaseDrawerStyled = styled(Drawer)`
  display: flex;
  flex-direction: column;
`
export const BaseDrawerCustomClose = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 99;
`
